import { render, staticRenderFns } from "./Asteroid1.vue?vue&type=template&id=6fd307e7&scoped=true&"
import script from "./Asteroid1.vue?vue&type=script&lang=js&"
export * from "./Asteroid1.vue?vue&type=script&lang=js&"
import style0 from "./Asteroid1.vue?vue&type=style&index=0&id=6fd307e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd307e7",
  null
  
)

export default component.exports